import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { Grid, Typography, Stack, Button } from "@mui/material";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import { getAllDisputes, approveDispute, rejectDispute } from "../../apis";
import HRManagerCard from "./components/HRManagerCard";
import SelectedHRManager from "./components/SelectedHRManager";
import AdminDrawer from "../../components/AdminDrawer";

const DisputesManager = () => {
  const [disputesData, setDisputesData] = useState([]);
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getAllDisputes();
      setDisputesData(result.data.disputes);
      setLoading(false);
    };

    fetchData();
  }, []);

  // const HandleOnClick = (id) => {
  //   const filteredResult = queries.filter((item) => item._id == id);
  //   setSelectedQuery(filteredResult[0]);
  // };

  // const fetchNewData = async () => {
  //   const result = await getQueries();
  //   setQueries(result.data.queries);
  //   setLoading(false);
  //   setSelectedQuery(null);
  // };

  // const clickhandler = (id) => {
  //   const filteredResult = disputesData.filter((item) => item._id == id);

  //   setSelectedDispute(filteredResult[0])
  // };
  const approveHandler = async (item) => {
    const response = await approveDispute({
      reason: item.reason,
      details: item.details,
      amount: item.amount,
      email: item.email,
      id: item._id,
    });
    const result = await getAllDisputes();
    setDisputesData(result.data.disputes);
  };

  const rejectHandler = async (item) => {
    const response = await rejectDispute({
      reason: item.reason,
      details: item.details,
      amount: item.amount,
      email: item.email,
      id: item._id,
    });
    const result = await getAllDisputes();
    setDisputesData(result.data.disputes);
  };

  return (
    <>
      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="Disputes Manager" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={10}>
                <Typography className="mb-16" variant="h6">
                  Disputes
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {disputesData.length && loading == false ? (
                      disputesData.map((item) => (
                        <div
                          style={{
                            borderBottom: "1px solid #EEEBEF",
                            marginTop: "20px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            // cursor: "pointer",
                          }}
                          // onClick={() => clickhandler(item._id)}
                        >
                          <Typography
                            style={{
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {item.reason}
                          </Typography>
                          <Typography className="ammanat-darker-gray">
                            {item.email}
                          </Typography>
                          <Typography className="ammanat-darker-gray">
                            Amount: {item.amount}
                          </Typography>
                          <Typography className="ammanat-darker-gray">
                            {item.details}
                          </Typography>
                          <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={3}
                          >
                            <Button
                              variant="outlined"
                              className="default-color default-border"
                              onClick={() => rejectHandler(item)}
                            >
                              Reject
                            </Button>
                            <Button
                              variant="contained"
                              className="primary-button"
                              onClick={() => approveHandler(item)}
                            >
                              Approve
                            </Button>
                          </Stack>
                        </div>
                      ))
                    ) : disputesData.length == 0 && loading == false ? (
                      <>
                        <Typography>No Disputes Found</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div>
              </Grid>
              {/* <Grid item sm={7}>
                {selectedQuery != null ? (
                  <SelectedHRManager
                    currentQueryDetails={selectedQuery}
                    handleFetchNewData={fetchNewData}
                  />
                ) : null}
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default DisputesManager;
